import { createVanIconComponent } from "./van"

const PhoneCircle = createVanIconComponent("phone-circle")
export default PhoneCircle
